import { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "components/features/ErrorHandler/ErrorPage";
import { saveToErrorLog } from "api/axios";

interface ErrorHandlerProps {
  children: ReactNode;
}
function ErrorHandler({ children }: ErrorHandlerProps) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorPage}
      onError={(error, errorInfo) => {
        void saveToErrorLog(
          JSON.stringify({
            errorMsg: error.message,
            stack: error.stack,
          }),
        );
      }}
    >
      {children}
    </ErrorBoundary>
  );
}

export default ErrorHandler;
